var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TheMovies',{attrs:{"id":"movieHolder","columns":_vm.num_columns,"rows":_vm.num_rows},on:{"mousedown":_vm.startDrag,"mousemove":_vm.doDrag,"mouseup":_vm.stopDrag}})}
var staticRenderFns = []

export { render, staticRenderFns }